import React from "react";
import "../style/HomeServices.css";
import {
  FaFileInvoice,
  FaPlane,
  FaShip,
  FaTruck,
  FaShippingFast,
  FaWarehouse,
} from "react-icons/fa";

const HomeServices = () => {
  return (
    <section className="home-services">
      <div className="home-services-container">
        <h2>Our Services</h2>
        <p className="subtitle">
          End-to-end logistics and supply chain solutions across India and worldwide.
        </p>

        <div className="home-services-grid">
          <div className="home-service-card">
            <FaFileInvoice className="icon" />
            <h3>Customs Clearance</h3>
            <p>
              Import & export clearance with complete documentation, duty
              consultation, and port & airport support.
            </p>
          </div>

          <div className="home-service-card">
            <FaPlane className="icon" />
            <h3>Freight Forwarding</h3>
            <p>
              Air, sea, road & rail freight with door-to-door delivery and
              heavy cargo handling.
            </p>
          </div>

          <div className="home-service-card">
            <FaShip className="icon" />
            <h3>Container Booking</h3>
            <p>
              FCL & LCL containers, reefer cargo, tracking, and stuffing &
              destuffing services.
            </p>
          </div>

          <div className="home-service-card">
            <FaTruck className="icon" />
            <h3>Domestic & International Transport</h3>
            <p>
              Pan India and cross-border logistics for B2B and B2C commercial shipments.
            </p>
          </div>

          <div className="home-service-card">
            <FaShippingFast className="icon" />
            <h3>Courier & Express</h3>
            <p>
              DHL, UPS, FedEx & DPD services for documents, parcels and urgent deliveries.
            </p>
          </div>

          <div className="home-service-card">
            <FaWarehouse className="icon" />
            <h3>Commercial Solutions</h3>
            <p>
              Bulk shipments, e-commerce fulfillment, warehousing and reverse logistics.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeServices;
